'use client';

import { useUserCanIssueBonuses } from '@/hooks/bonuses';
import { useGetCommonStore } from '@/store';

export const useCanExchangeBonuses = () => {
  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUser = useCommonStore.use.pendingUser();
  const isUserCanIssueBonuses = useUserCanIssueBonuses();

  return isAuthenticated && (pendingUser || isUserCanIssueBonuses);
};
